import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SplashScreen } from '@awesome-cordova-plugins/splash-screen/ngx';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';
import { Platform } from '@ionic/angular';
import * as Sentry from '@sentry/angular';
import { AuthActions, AuthObserver } from 'ionic-appauth';
import { first, take } from 'rxjs/operators';
import { CustomAuthService } from './auth/custom-auth.service';
import { UAVMapService } from './drones/service/uavmap.service';
import { CrowdFlowMapService } from './map-container/service/crowd-flow-map.service';
import { MissionLogBookService } from './mission-log-book/service/mission-log-book.service';
import { MissionsService } from './mission/service/missions.service';
import { AppStateService } from './service/app-state.service';
import { NetworkService } from './service/network.service';
import { BuildingService } from './smart-building/service/building.service';
import { DevicesService } from './smart-building/service/devices.service';
import { CitizenReportService } from './social-media/service/citizen-report.service';
import { VehicleService } from './vehicle/service/vehicle.service';
import { SocialMediaService } from './social-media/service/social-media.service';
import { environment } from '../environments/environment';
import { GlobalStateQuery } from './state/global.appstate.query';
import { ServerSideProcessorService } from './service/server-side-processor.service';
import { SocialMediaSearchService } from './social-media/service/social-media-search.service';
import { DataLoadingService } from './service/data-loading.service';

// eslint-disable-next-line no-var
declare var cordova;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  authObserver: AuthObserver; // Unused?
  observer: AuthObserver;

  lastConnectionStatus: 'connected' | 'disconnected';

  constructor(
    private auth: CustomAuthService,
    private missionService: MissionsService,
    private logbookService: MissionLogBookService,
    private platform: Platform,
    private router: Router,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private vehicleService: VehicleService,
    private uavVMapService: UAVMapService,
    /*Do not delete! Required for init of Websockets */
    private crowdFlowMapService: CrowdFlowMapService,
    private buildingService: BuildingService,
    private networkService: NetworkService,
    private devicesService: DevicesService,
    /*Do not delete! Required for init of Websockets */
    private socialMediaService: SocialMediaService,
    private appStateService: AppStateService,
    private citizenReportService: CitizenReportService,
    private globalStateQuery: GlobalStateQuery,
    private sspService: ServerSideProcessorService,
    private socialMediaSearchService: SocialMediaSearchService,
    private dataLoaderService: DataLoadingService
  ) {
    // Initialize app
    this.platform.ready().then((readySource) => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  ngOnInit() {

    this.observer = this.auth.addActionListener((authAction) => {
      // Check login state after every auth action.

      if (authAction.action === AuthActions.SignOutSuccess) {
        this.router.navigateByUrl('/serverconfig');
        if (environment.useSentry) {
          Sentry.configureScope((scope) => scope.setUser(null));
        }
      }

      if (authAction.action === AuthActions.LoadUserInfoSuccess) {
        this.appStateService.user = this.auth.session.user;
        if (environment.useSentry) {
          Sentry.setUser({
            email: this.appStateService.user?.email,
            name: this.appStateService.user?.username,
          });
        }
      }
      if (
        authAction.action === AuthActions.SignInFailed ||
        authAction.action === AuthActions.RefreshFailed ||
        authAction.action === AuthActions.LoadTokenFromStorageFailed
      ) {
        this.router.navigateByUrl('/serverconfig');
      }
    });

    this.auth.token.pipe(first(value => value != null), take(1)).subscribe(token => {
      if (this.auth.session.isAuthenticated) {
        this.dataLoaderService.loadAllData();
      }
    });


    this.platform.pause.subscribe(pause => {
      console.log('Entering pause mode');
    });
    this.platform.resume.subscribe(resume => {
      console.log('Resuming');
      this.dataLoaderService.loadAllData();
    });

    if (this.platform.is('cordova')) {
      this.networkService
        .watchNetworkChange()
        .pipe()
        .subscribe((status) => {
          if (status === 'connected') {
            console.log('connected, reloading');
            this.dataLoaderService.loadAllData();
          } else {
            console.log('connection lost');
          }
        });
    }
  }




  ngOnDestroy() {
    this.auth.removeActionObserver(this.observer);
  }
}
